// Phase 6 — Track E T-E3. Container primitive (hand-rolled).
//
// Centered max-width wrapper. Default max-width matches the AppShell's
// content column (1280px breakpoint, 7xl). Phase 6 routes are
// content-narrow (3xl/5xl); the prop lets a route opt in.

import * as React from 'react';
import { cn } from '../../lib/cn.js';

const widthClass = {
  sm: 'max-w-sm',
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '2xl': 'max-w-2xl',
  '3xl': 'max-w-3xl',
  '5xl': 'max-w-5xl',
  '7xl': 'max-w-7xl',
  full: 'max-w-full',
} as const;

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: keyof typeof widthClass;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, width = '7xl', ...props }, ref) => (
    <div
      ref={ref}
      className={cn('mx-auto w-full px-4 sm:px-6', widthClass[width], className)}
      {...props}
    />
  ),
);
Container.displayName = 'Container';
